import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';

import csmBusyScreen from '../../../ui/busyScreen/busyScreen';
import csmCommonSvc from '../../../util/CommonSvc/CommonSvc';

import './ChangeLoginDialog.css';
import changeLoginDialogTemplate from './ChangeLoginDialog.template.html';

export default angular
  .module('csm.com.ui.ChangeLoginDialog', [
    uiBootstrap,
    csmBusyScreen,
    csmCommonSvc
  ])
  .directive('matchModel', matchModelDirective)
  .service('ChangeLoginDialog', ChangeLoginDialogService).name;

matchModelDirective.$inject = [];
ChangeLoginDialogService.$inject = ['$uibModal', 'CommonSvc', 'Alert'];

/* @ngInject */ function matchModelDirective() {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: { modelToMatch: '=matchModel' },
    link: function (scope, element, attributes, ngModel) {
      ngModel.$validators.matchModel = function (modelValue) {
        return modelValue == scope.modelToMatch;
      };

      scope.$watch('modelToMatch', function () {
        ngModel.$validate();
      });
    }
  };
}

/*******************************************************************************
 * Service: ChangeLoginDialog
 *
 * Modal dialog allowing the user to change their login or password. Calls
 * CommonSvc to get the current user name and to update credentials.
 *******************************************************************************/
/* @ngInject */ function ChangeLoginDialogService($uibModal, CommonSvc, Alert) {
  /*-------------*/
  /* Controller. */
  /*-------------*/
  var controller = function ($uibModalInstance, CommonSvc) {
    var $ctrl = this;
    $ctrl.data = {};

    /***************************************************************************
     * cancel */
    /**
     * Dismiss the modal
     ***************************************************************************/
    $ctrl.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    /***************************************************************************
     * ok */
    /**
     * Make changes to the user's login
     ***************************************************************************/
    $ctrl.ok = function () {
      var credentials = {
        username: $ctrl.data.newUsername,
        password: $ctrl.data.newPassword,
        userPassword: $ctrl.data.currentPassword
      };

      CommonSvc.updateCredentials(credentials).then(
        function () {
          Alert.success('Your login has been updated!', 'Login Updated');
          $uibModalInstance.close('Success!');
        },
        function (resp) {
          Alert.error(resp.parsedResponse.message(), 'Update Failed');
        }
      );
    };

    /*-----------------------------------------*/
    /* Get the current user name from session. */
    /*-----------------------------------------*/
    CommonSvc.getUsername().then(function (resp) {
      $ctrl.data.username = resp.data;
    });
  };

  /*****************************************************************************
   * show */
  /**
   * Show the modal dialog for changing the login credentials.
   *****************************************************************************/
  this.show = function () {
    $uibModal.open({
      animation: true,
      template: changeLoginDialogTemplate,
      controller: controller,
      controllerAs: '$ctrl',
      size: 'md',
      backdrop: 'static',
      windowClass: 'popup ChangeLoginDialog'
    });
  };
}
